module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"confirmRemovalArea":"Are you sure you want to remove area: {areaName}?"},"no":{"confirmRemovalArea":"Er du sikker på at du vil fjerne området: {areaName}?"}}')
  delete Component.options._Ctor
}
